<template>


    <div class="modal fade bn-modal" ref="loginModal" data-backdrop="static" id="loginModal" tabindex="-1" role="dialog" aria-labelledby="loginModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="loginModalLabel">Login</h5>
                </div>
                <div class="modal-body">
                    <p>Log in to your account.</p>
                    <div class="alert alert-danger" v-if="error">
                        <p>{{ error }}</p>
                    </div>
                    <div class="form-group">
                        <input
                                type="text"
                                class="form-control"
                                placeholder="Enter your email"
                                v-model="credentials.email"
                        >
                    </div>
                    <div class="form-group">
                        <input  v-on:keypress="checkEnterKey"
                                type="password"
                                class="form-control"
                                placeholder="Enter your password"
                                v-model="credentials.password"
                        >
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="submit()">Access</button>
                </div>
            </div>
        </div>
    </div>



</template>

<script>
    import auth from '../../store/modules/auth'
    export default {
        data() {
            //this.$refs.loginModal.show()
            return {
                // We need to initialize the component with any
                // properties that will be used in it
                credentials: {
                    email: '',
                    password: ''
                },
                error: ''
            }
        },
        mounted:function(){
            $(this.$refs.loginModal).modal('show');

        },
        methods: {
            submit() {
                let credentials = {
                    email: this.credentials.email,
                    password: this.credentials.password
                };
                // We need to pass the component's this context
                // to properly make use of http in the auth service
                auth.login(this, credentials,'organizations')
            },
            checkEnterKey(e){
                if (e.which == '13') {
                    this.submit();
                }
            }
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/pages/Login.vue